exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.active[data-v-3b984273] {\n  z-index: 2;\n  color: #fff;\n  background-color: #20986d;\n  border-color: #20986d;\n}\n", ""]);

// exports
